import { useParams } from "react-router-dom"
import { z } from "zod"
import { Box, Stack } from "@mui/material"
import Calendar from "@/components/calendar/Calendar"
import useIsMobile from "@/hooks/useIsMobile"
import { Helmet } from "react-helmet-async"
import LeftAdvertisements from "@/components/advertisements/LeftAdvertisements"
import RightAdvertisements from "@/components/advertisements/RightAdvertisements"
import useIsTablet from "@/hooks/useIsTablet"

const dateParamSchema = z.object({
  year: z.coerce.number().int().min(1900),
  month: z.coerce.number().int().min(1).max(12),
})

const NewPage = () => {
  const isMobile = useIsMobile()
  const isTablet = useIsTablet()
  const { year: yearParam, month: monthParam } = useParams()
  const dateParamValidation = dateParamSchema.safeParse({
    year: yearParam,
    month: monthParam,
  })

  // Validate calendar param with Zod. If it's invalid
  // just go with today's date
  let year: number
  let month: number
  if (dateParamValidation.success) {
    year = dateParamValidation.data.year
    month = dateParamValidation.data.month - 1
  } else {
    const date = new Date()
    year = date.getFullYear()
    month = date.getMonth()
  }

  const selectedDate = new Date(year, month)

  return (
    <>
      <Helmet>
        <title>843Hub | Charleston Events | Weekend Charleston Events</title>
        <meta
          name="description"
          content="Our comprehensive calendar on things to do in Charleston this weekend and beyond. Discover what the Holy City has to offer! Charleston events this Friday."
        />
      </Helmet>
      <Box
        className="theme-bluecontainer"
        sx={{
          display: "flex",
          width: "100%",
          paddingTop: isMobile ? "" : "3rem",
          paddingBottom: "3rem",
        }}
      >
        <Stack
          direction="row"
          spacing={2}
          sx={{
            width: "100%",
            justifyContent: "center",
            px: isMobile ? "0rem" : isTablet ? "1rem" : "2rem",
          }}
        >
          {!isMobile && !isTablet && <LeftAdvertisements />}
          <Calendar selectedDate={selectedDate} />
          {!isMobile && <RightAdvertisements />}
        </Stack>
      </Box>
    </>
  )
}

export default NewPage
